export const CustomAlertDialogTypes = {
    ONE_TIME: 'ONE_TIME',
    RECURRENT: 'RECURRENT',
} as const;

export type CustomAlertDialogType = (typeof CustomAlertDialogTypes)[keyof typeof CustomAlertDialogTypes];
